import { FirestoreOrder, Order } from '@lib/types';

export function fromFirestoreOrderToOrder(
  firestoreOrder: FirestoreOrder,
): Order {
  return {
    ...firestoreOrder,
    orderMessage: {
      ...firestoreOrder.orderMessage,
      data: {
        ...firestoreOrder.orderMessage.data,
        categories: firestoreOrder.orderMessage.data.categories.map((cat) => ({
          ...cat,
          items: cat.items.map((item) => ({
            ...item,
            item: {
              ...item.item,
              topping: item.item.topping.map((top) => ({
                category: {
                  uuid: top.categoryUUID,
                  arName: top.categoryArName,
                  enName: top.categoryEnName,
                },
                extraItems: top.extraItems.map((extra) => ({
                  orderItemExtraUUID: extra.orderItemExtraUUID,
                  price: extra.price,
                  size: {
                    enName: extra.sizeEnName,
                    arName: extra.sizeArName,
                    uuid: extra.sizeUUID,
                  },
                  item: {
                    enName: extra.itemEnName,
                    arName: extra.itemArName,
                    uuid: extra.itemUUID,
                  }
                })),
              })),
            },
          })),
        })),
      },
      trace: {
        created: {
          by: firestoreOrder.orderMessage.trace.created.by,
          at: firestoreOrder.orderMessage.trace.created.at.toDate(),
        },
        updated: {
          by: firestoreOrder.orderMessage.trace.updated.by,
          at: firestoreOrder.orderMessage.trace.updated.at.toDate(),
        },
      },
    },
    orderStateTrace: {
      ...firestoreOrder.orderStateTrace,
    },
    expireAt: firestoreOrder.expireAt?.toDate(),
  };
}
